import { useEffect, useRef } from 'react';
import { Typography, useToaster, useTranslate } from '@prenuvo/halo-web';

import { useAuthStore } from '@/store';

export function UnauthenticatedHandler() {
  const hasShownToast = useRef(false);
  const { addToast } = useToaster();

  const translate = useTranslate();

  const { showUnauthenticatedToast } = useAuthStore();

  useEffect(() => {
    if (showUnauthenticatedToast && !hasShownToast.current) {
      hasShownToast.current = true;

      addToast({
        description: (
          <span className="flex flex-row gap-4 p-1">
            <Typography
              as="span"
              className="text-red-500 dark:text-red-500"
              translationKey="AUTHENTICATION.ERROR.DESCRIPTION"
            />
          </span>
        ),
        duration: 3000,
        title: translate('AUTHENTICATION.ERROR.TITLE'),
        variant: 'error',
      });
    }
  }, [showUnauthenticatedToast, translate, addToast]);

  return null;
}
